import KendoUpload from '../KendoUpload'

let KendoUploadInstaller = class {
    static install(Vue) {
        Vue.component(KendoUpload.name, KendoUpload)
    }
}

export default KendoUploadInstaller

// Automatic installation if Vue has been added to the global scope.
if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(KendoUploadInstaller)
}


// WEBPACK FOOTER //
// ./packages/kendo-upload-vue-wrapper/src/kendo-upload-installer/index.js